import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { Address, RelativeData } from 'models/Auth'

interface ME {
  id: number,
  username: string,
  person_general: {
    first_name: string,
    last_name: string,
    full_name: string,
    email: string,
    cpf: string,
    date_birth: string,
    date_created: string,
    date_published: string,
    cellphone_number: string,    
    phone_number: string,
    picture_url: string,
    gender: string,
    address_data: Address,
    relative_data: RelativeData    
  }
  person_profile: Array<{
    plans: Array<{
      id: number
      partner_plan_id: number
      partner_plan_code: string
      partner_plan_name: string
      partner_plan_is_particular: boolean
      partner_plan_has_validity: boolean
      status_code: string
      status_name: string
      card_number: string
      default: boolean
      plan_group: {
        id: number
        category: string
        code: string
        name: string
        has_vitrine: boolean
        logo_url: string
        validity_renew: boolean
        allows_reservation: boolean
      },
      eligible_to_schedule: boolean
    }>,
  }>,
}

export async function getUserData(): Promise<ME> {
  const { data } = await axios.get<ME>(apiEndpoints.ME)

  return data
}